import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/blue-arrow-left.svg'
import _imports_1 from '@/assets/printing-assets/issue-2.svg'


_pushScopeId("data-v-98d552b4")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Return to Troubleshooting", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { id: "info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "title" }, "My print is shifted up or down", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If your printed artwork is shifted up or down from the labels the issue is likely related to your printed paper settings. In your printer settings set your "),
  /*#__PURE__*/_createElementVNode("strong", null, "Paper"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "Media Type"),
  /*#__PURE__*/_createTextVNode(" to "),
  /*#__PURE__*/_createElementVNode("strong", null, "Labels"),
  /*#__PURE__*/_createTextVNode(" or a similar setting such as "),
  /*#__PURE__*/_createElementVNode("strong", null, "Heavyweight Paper"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " If your paper setting is correct you may need to manually configure your template to work with your printer. ", -1)
const _hoisted_10 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _createElementVNode("h1", _hoisted_1, [
          _createElementVNode("div", {
            id: "return",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.returnToTroubleShooting && _ctx.returnToTroubleShooting(...args)))
          }, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            (_ctx.clientDimensions.width <= 900)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              id: "template-select",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.configureTemplate && _ctx.configureTemplate(...args)))
            }, "Manually Configure My Template")
          ]),
          (_ctx.clientDimensions.width > 900)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2)
  ]))
}